import React, { useReducer } from 'react'
import TicketContext from './TicketContext'
import App from '../App'

const initialState = {
  initial: false,
  appColor: 'DE1721',
  appFormato: '',
  appLogo: '',
  numeroCaso: '',
  verificacion: ''
}
/* eslint-disable  @typescript-eslint/no-explicit-any */
const ReclamoReducer = (state:any = initialState, action:any) => {
  const newState = {
    ...state,
    ...action,
    initial: false,
  }
  if ('reset' in action)  {
    return {
      initial: false,
      appColor: state.appColor,
      appFormato: state.appFormato,
      appLogo: state.appLogo,
      numeroCaso: state.numeroCaso,
      verificacion: state.verificacion
    }
  }
  if (state.initial === true) {
    const localStore = window.localStorage.getItem('reclamo')
    if (localStore) {
      const localState = JSON.parse(localStore)
      if (localState?.initial === false) {
        return {
          initial: false,
          appColor: 'DE1721',
          appFormato: '',
          appLogo: '',
          numeroCaso: localState.numeroCaso || '',
          verificacion: localState.verificacion || ''
        }
      }
    }
  } 
  window.localStorage.setItem('reclamo', JSON.stringify(newState))
  return newState
}

const ContextState = () => {
  const [stateReclamoReducer, dispatchReclamoReducer] = useReducer(
    ReclamoReducer,
    initialState
  )


  const handleInput = (evt : React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    switch (evt.target.type) {
    case 'checkbox':
      const chbox = evt.target as HTMLInputElement
      updateField(chbox.name,chbox.checked?chbox.value:'')
      break
    default:
      const name = evt.target.name
      const newValue = evt.target.value
      updateField(name,newValue)
    }
  }

  const updateField = (name:string, newValue:string) => {
    dispatchReclamoReducer({ [name]: newValue})
  }

  return (
    <TicketContext.Provider
      value={{
        ticket: stateReclamoReducer,
        handleInput,
        updateField
      }}
    >
      <App />
    </TicketContext.Provider>
  )
}

export default ContextState
